import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'my-app',
  template: `
      <app-header *ngIf="router.url!=='/' && router.url!=='/login'"></app-header>
      <router-outlet></router-outlet>
  `,
  providers: []

})
export class AppComponent {
    constructor(public readonly router: Router) { }
}
